/* key stored in globalDataService cause we lose notification message leaving component */
/** key for withdraw success message */
export const WITHDRAW_SUCCESS_MESSAGE = 'withdrawSuccessMessage';
/** key for submit success message */
export const SUBMIT_SUCCESS_MESSAGE = 'submitSuccessMessage';
/** key for delete success message */
export const DELETE_SUCCESS_MESSAGE = 'deleteSuccessMessage';
/** final check success message */
export const FINAL_CHECK_SUCCESS_MESSAGE = 'finalSuccessMessage';

/** TabIndexes */
export const TABINDEX_REQUESTS = 4;

/** outcome */
export const OUTCOME_PROJECT_EDIT = 'outcomeProjectEdit';

/** objects */
export const FUNDING_NOTIFICATION = 'fundingNotification';
export const PROJECT = 'project';

/** rights */
export const RIGHT_CREATE_BUDGETSOURCE = 'RIGHT_RM_FIM_CREATE_BUDGETSOURCE';

/* budget_position hiskeyId 101 - personal funds */
export const PERSONAL_FUNDS_HISKEYID = 101;
/* budget_position hiskeyId 102 - material funds */
export const MATERIAL_FUNDS_HISKEYID = 102;
/* budget_position hiskeyId 103 - investment funds */
export const INVESTMENT_FUNDS_HISKEYID = 103;
/* budget_position hiskeyId 104 - travel funds */
export const TRAVEL_FUNDS_HISKEYID = 104;
/* budget_position hiskeyId 106 - others funds */
export const OTHER_FUNDS_HISKEYID = 106;
/* budget_position hiskeyId 105 - overhead funds */
export const OVERHEAD_FUNDS_HISKEYID = 105;

/* k_research_fund_type hiskeyId 20 - calculated funds */
export const CALCULATED_FUNDS_HISKEYID = 10;
/* k_research_fund_type hiskeyId 10 - requested funds */
export const REQUESTED_FUNDS_HISKEYID = 20;
/* k_research_fund_type hiskeyId 30 - granted funds */
export const GRANTED_FUNDS_HISKEYID = 30;

/* budget_source_type hiskeyId 17 - third-party funds */
export const THIRD_PARTY_FUNDS_HISKEYID = 17;

/* project_main_logo_hiskeyId 26
 * projext_other_logo_hiskeyid 27
 */
export const ALLOWED_LOGO_CATEGORY_HISKEYS = {
    mainLogo: 26,
    otherLogo: 27
};
